import { useCallback } from 'react';
import { useMovableInkIntegrationContext } from '../../../contexts/MovableInkIntegrationContext';
import { useMovableInkBlockContext } from '../../../contexts/MovableInkBlockContext';
import { useMovableInkCampaignContext } from '../../../contexts/MovableInkCampaignContext';
import { usePanelContext } from '../../../contexts/Panel';

export const useRefetchCampaignsOrBlocks = () => {
  const { selectedIntegration } = useMovableInkIntegrationContext();
  const { campaignId, hasCampaignsError, refetchCampaignsByTokenId, isFetchingCampaigns } =
    useMovableInkCampaignContext();
  const { debouncedPanelSearch } = usePanelContext();
  const { refetchBlocks, hasBlocksError, isFetchingBlocks } = useMovableInkBlockContext();

  return useCallback(() => {
    // only fetch if campaigns or blocks aren't fetching and there is a selected integration
    if (selectedIntegration && !isFetchingCampaigns && !isFetchingBlocks) {
      if (hasCampaignsError) {
        refetchCampaignsByTokenId({ tokenId: selectedIntegration.tokenId });
      } else if (hasBlocksError) {
        refetchBlocks({
          tokenId: selectedIntegration.tokenId,
          campaignId,
          search: debouncedPanelSearch,
        });
      }
    }
  }, [
    selectedIntegration,
    campaignId,
    debouncedPanelSearch,
    refetchBlocks,
    refetchCampaignsByTokenId,
    isFetchingCampaigns,
    isFetchingBlocks,
  ]);
};
